import { useGetBranchInventoryAccountsQuery } from '@/queries/branch/hooks';

export const useInventoryAccount = () => {
    const { data: inventoryAccounts, ...rest } = useGetBranchInventoryAccountsQuery();
    return { hasInventoryAccount: Boolean(inventoryAccounts?.data?.length), ...rest };
};
